/* MIT License
Copyright (c) 2023 Simon Y. Blackwell

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
 */

/* MIT License
Copyright (c) 2023 Simon Y. Blackwell & 2019 Ophir LOJKINE

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
 */

import {createIterable} from "./create-iterable.js";

function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
}

/* Portions of algorithm taken from https://gist.github.com/lovasoa/3361645 under MIT license */
const unionizor = (iterating) => {
    let i, j, ctx, nOthers, thisDone, args, memory;
    return function(...args) {
        args = args.filter(onlyUnique);
        if(!ctx) {
            ctx = Array.isArray(this) ? this : [...this];
            nOthers = args.length - 1;
            memory = new Set();
            thisDone = false;
            i = 0;
            j = 0;
        }
        while(i<=nOthers) {
            let array = thisDone ? args[i++] : ctx;
            array = array===ctx || Array.isArray(array) ? array : [...array];
            const len = array.length;
            while(j<len) {
                const elem = array[j++];
                if(iterating && !memory.has(elem)) {
                    memory.add(elem);
                    return {value:elem}
                }
                memory.add(elem);
            }
            thisDone = true;
            j=0;
        }
        ctx = null;
        return iterating ? {done:true} : this instanceof Set ? memory : [...memory];
    }
}

const union = unionizor(),
//union.iterable = iterable;
iterableUnion = createIterable(unionizor)


export {union,iterableUnion,union as default};

